import { ApolloLink } from "@apollo/client";
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { relayStylePagination } from "@apollo/client/utilities";
import { createApolloProvider } from "@vue/apollo-option";
import { SentryLink } from "apollo-link-sentry";
import { onError } from "@apollo/client/link/error";

const httpLink = createHttpLink({
  uri: ({ operationName }) => {
    return process.env.SHOPIFY_STOREFRONT_API_URL + "?op=" + operationName;
  },
});

const cache = new InMemoryCache({
  typePolicies: {
    Collection: {
      fields: {
        products: relayStylePagination(),
      },
    },
  },
});

const sentryLink = new SentryLink();

//Handle errors
const errorLink = onError((error) => {
  console.log("APOLLO", error);
});

let link = ApolloLink.from([sentryLink, errorLink, httpLink]);

const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      "X-Shopify-Storefront-Access-Token":
        process.env.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    },
  };
});

link = authLink.concat(link);

export const client = new ApolloClient({
  link,
  cache,
});

export const apolloProvider = createApolloProvider({
  defaultClient: client,
});
